<template>
	<div>
		<v-card
			v-for="(invoices, yearMonth) in invoiceMonths"
			:key="yearMonth"
		>
			<v-card-title class="d-flex align-center">
				<v-icon
					icon="$invoices"
					start
				/>
				<translate>
					Invoices
				</translate>
				&nbsp;
				{{ yearMonth }}
			</v-card-title>
			<v-card-text>
				<v-data-table
					:headers="headers"
					:items="invoices"
					hide-default-footer
				>
					<template #item.identifier="{ item }">
						<a :href="`/bo/invoices/view?id=${item.id}`">
							{{ item.identifier }}
						</a>
					</template>
				</v-data-table>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>

export default {
	name: 'SettlementReportTable',
	props: {
		paymentPsps: {
			type: Array,
			required: true
		},
	},
	data () {
		return {
			invoiceMonths: {
			}
		};
	},

	computed: {
		/**
		 * Concatenation of all error messages
		 *
		 * @returns {Array}
		 */
		headers () {
			return [
				{
					title: this.$gettext('Invoice Number'), value: 'identifier', sortable: false, filterable: true,
				},
				{
					title: this.$gettext('Date'), value: 'date', sortable: false, filterable: true,
				},
				{
					title: this.$gettext('Total (including tax)'), value: 'amount', sortable: false, filterable: false,
				},
			];
		},
	},

	created () {
		this.paymentPsps.forEach(this.extractInvoice);
	},


	methods: {

		/**
		 *
		 * @param {object} paymentPsp
		 */
		extractInvoice (paymentPsp) {
			const eurFormatter = new Intl.NumberFormat('en-US', {
				style: 'currency',
				currency: 'EUR',
			});

			const date = new Date(paymentPsp.payment.createdAt);

			const yearMonth = date.getFullYear() + '-' + (date.getMonth() + 1);
			const yearMonthDay = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDay();

			const existingYearMonth = this.invoiceMonths[yearMonth] || [];

			paymentPsp.payment.invoice.date = yearMonthDay;
			paymentPsp.payment.invoice.amount = eurFormatter.format(paymentPsp.payment.amount);
			existingYearMonth.push(paymentPsp.payment.invoice);
			this.invoiceMonths[yearMonth] = existingYearMonth;
		},
	},
};
</script>
